import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

const STORAGE_KEY_TOKEN   = 're_dev_token';
const STORAGE_KEY_ACCOUNT = 're_dev_account';
const STORAGE_KEY_IS_ADMIN = 're_dev_is_admin';

export function AuthProvider({ children }) {
  const [token,   setToken]   = useState(null);
  const [account, setAccount] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken   = localStorage.getItem(STORAGE_KEY_TOKEN);
    const savedAccount = localStorage.getItem(STORAGE_KEY_ACCOUNT);
    const savedIsAdmin = localStorage.getItem(STORAGE_KEY_IS_ADMIN);
    if (savedToken && savedAccount) {
      try {
        setToken(savedToken);
        setAccount(JSON.parse(savedAccount));
        setIsAdmin(savedIsAdmin === 'true');
      } catch {
        localStorage.removeItem(STORAGE_KEY_TOKEN);
        localStorage.removeItem(STORAGE_KEY_ACCOUNT);
        localStorage.removeItem(STORAGE_KEY_IS_ADMIN);
      }
    }
    setLoading(false);
  }, []);

  function login(newToken, newAccount, newIsAdmin = false) {
    setToken(newToken);
    setAccount(newAccount);
    setIsAdmin(newIsAdmin);
    localStorage.setItem(STORAGE_KEY_TOKEN,    newToken);
    localStorage.setItem(STORAGE_KEY_ACCOUNT,  JSON.stringify(newAccount));
    localStorage.setItem(STORAGE_KEY_IS_ADMIN, String(newIsAdmin));
  }

  function logout() {
    setToken(null);
    setAccount(null);
    setIsAdmin(false);
    localStorage.removeItem(STORAGE_KEY_TOKEN);
    localStorage.removeItem(STORAGE_KEY_ACCOUNT);
    localStorage.removeItem(STORAGE_KEY_IS_ADMIN);
  }

  return (
    <AuthContext.Provider value={{ token, account, isAdmin, login, logout, loading, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
